// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ErrorFallback {\r\n  padding: 10px;\r\n  color: var(--active-color);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
